import { type ButtonHTMLAttributes, type JSX, type ReactNode } from "react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: "default" | "primary" | "ghost" };
export function Button({ variant = "default", className, children, ...rest }: ButtonProps): JSX.Element {
  const cls = ["voss-btn", variant !== "default" ? `voss-btn--${variant}` : "", className ?? ""].filter(Boolean).join(" ");
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { label: string };
export function IconButton({ label, className, children, ...rest }: IconButtonProps): JSX.Element {
  return (
    <button className={["voss-iconbtn", className ?? ""].filter(Boolean).join(" ")} aria-label={label} title={label} {...rest}>
      {children}
    </button>
  );
}

type BadgeTone = "neutral" | "good" | "warn" | "accent";
export function Badge({ tone = "neutral", dot, children }: { tone?: BadgeTone; dot?: boolean; children: ReactNode }): JSX.Element {
  return (
    <span className={["voss-badge", tone !== "neutral" ? `voss-badge--${tone}` : ""].filter(Boolean).join(" ")}>
      {dot ? <span className="voss-badge__dot" /> : null}
      {children}
    </span>
  );
}

export function Kbd({ children }: { children: ReactNode }): JSX.Element {
  return <kbd className="voss-kbd">{children}</kbd>;
}

export function Switch({ checked, onChange, label }: { checked: boolean; onChange: (next: boolean) => void; label: string }): JSX.Element {
  return (
    <button type="button" role="switch" aria-checked={checked} aria-label={label} className="voss-switch" onClick={() => onChange(!checked)}>
      <span className="voss-switch__thumb" />
    </button>
  );
}
